import { useAuth } from '@/app/providers/AuthProvider';
import { useDashboardStats } from '@/features/dashboard/hooks/useDashboardStats';
import { useLocalScanStats } from '@/features/dashboard/hooks/useLocalScanStats';
import { SyncStatusBadge } from '@/features/dashboard/components/SyncStatusBadge';
import { StatCard } from '@/shared/components/StatCard';
import { Spinner } from '@/shared/components/Spinner';
import { EmptyState } from '@/shared/components/EmptyState';

export function DashboardPage() {
  const { user } = useAuth();
  const { stats: serverStats, isLoading, error } = useDashboardStats(user?.exhibitorId ?? undefined);
  const localStats = useLocalScanStats();

  if (isLoading) {
    return (
      <div style={{ display: 'flex', justifyContent: 'center', padding: 'var(--space-7)' }}>
        <Spinner label="Loading dashboard" />
      </div>
    );
  }

  if (error || !serverStats) {
    return <EmptyState icon="⚠" title="Couldn't load dashboard" description={error ?? undefined} />;
  }

  return (
    <div>
      <h1 className="font-display" style={{ fontSize: '1.375rem', marginBottom: 'var(--space-4)' }}>
        Hi {user?.firstName ?? 'there'},
      </h1>

      <SyncStatusBadge />

      <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 'var(--space-3)', marginBottom: 'var(--space-6)' }}>
        <StatCard label="Today's scans" value={localStats?.scannedToday ?? serverStats.todaysScans} />
        <StatCard label="Successful uploads" value={serverStats.successfulUploads} tone="success" />
        <StatCard label="Pending uploads" value={localStats?.pending ?? '—'} />
        <StatCard
          label="Failed uploads"
          value={localStats?.failed ?? 0}
          tone={(localStats?.failed ?? 0) > 0 ? 'danger' : 'default'}
        />
      </div>

      {/* Top Exhibitors — temporarily hidden from the exhibitor-facing
          dashboard (2026-11-04). Not deleted: re-enable by uncommenting
          once the design for this section is revisited. The underlying
          data (serverStats.topExhibitors) is still fetched and available
          here unchanged -- only the rendering is disabled. */}
      {/*
      {serverStats.topExhibitors.length > 0 && (
        <>
          <h2 className="font-display" style={{ fontSize: '1.125rem', marginBottom: 'var(--space-3)' }}>
            Top exhibitors
          </h2>
          <div style={{ display: 'flex', flexDirection: 'column', gap: 'var(--space-2)' }}>
            {serverStats.topExhibitors.map((ex, i) => (
              <div
                key={ex.exhibitorId}
                style={{
                  display: 'flex',
                  justifyContent: 'space-between',
                  padding: 'var(--space-3) var(--space-4)',
                  background: 'var(--surface)',
                  border: '1px solid var(--border)',
                  borderRadius: 'var(--radius-md)'
                }}
              >
                <span>
                  {i + 1}. {ex.companyName}
                </span>
                <span className="font-mono" style={{ color: 'var(--text-muted)' }}>
                  {ex.scanCount}
                </span>
              </div>
            ))}
          </div>
        </>
      )}
      */}
    </div>
  );
}